import React from "react";

export default function ConfirmModal({ open, title, message, confirmLabel = "Confirm", danger = true, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="adm-modal-bg open" onClick={onCancel}>
      <div className="adm-modal" style={{ width: 420 }} onClick={e => e.stopPropagation()}>
        <div className="adm-modal-head">
          <span className="adm-modal-title">{title}</span>
          <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={onCancel}>✕</button>
        </div>
        <p style={{ color: "#94a3b8", fontSize: 14, lineHeight: 1.6, margin: "12px 0 20px" }}>{message}</p>
        <div className="adm-modal-footer">
          <button className="adm-btn" onClick={onCancel}>Cancel</button>
          <button className={`adm-btn ${danger ? "adm-btn-danger" : "adm-btn-primary"}`} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
